if (!customElements.get('products-toolbar')) {
	class ProductsToolbar extends HTMLElement {
		constructor() {
			super();
			window.initLazyScript(this, this.init.bind(this));
		}

		init() {
			this.filtersComponent = document.querySelector('facet-filters');
			this.filtersColumn = document.querySelector('.main-products-grid__filters');
			this.layoutSwitcher = this.querySelector('.products-toolbar__layout');
			this.compareToggle = document.getElementById('compare-switch');
			this.sortBy = this.querySelector('.products-toolbar__sort');
			this.productsGrid = document.querySelector('.main-products-grid');
			document.addEventListener('click', this.handleDocumentClick.bind(this));
			this.menuFilters = document.getElementById('menu-filters');

			if (this.filtersColumn) {
        		this.filterToggle = this.querySelector('.js-toggle-filters');
        		if (!this.filterToggle) {
          			this.filterToggle = this.menuFilters
            		? this.menuFilters.querySelector('.js-toggle-filters')
            		: null;
        			}
				if (this.filterToggle) {
					this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
				}
			}
				// Add event listeners for mobile filter menu
				const headerCloseButton = this.filtersComponent.querySelector('.boa-filters-mobile-header-button');
				const footerSubmitButton = this.filtersComponent.querySelector('.boa-filters-mobile-footer-button');
				const resetAllButtonDrawer = this.filtersComponent.querySelector('.boa-filters-footer-button-reset');
				headerCloseButton.addEventListener('click', () => {
					this.toggleFilters();
				});
				footerSubmitButton.addEventListener('click', (event) => {
					updatePriceRangeParams('drawerSlider', 'modalSlider', false);
					saveFilterState(event);
					this.toggleFilters();
				});
				resetAllButtonDrawer.addEventListener('click', () => {
					const urlFiltersParams = JSON.parse(url.searchParams.get(filtersUrlParam));
					const minPrice = getUrlSearchParams('min_price');
					const maxPrice = getUrlSearchParams('max_price');
					if((!urlFiltersParams || !urlFiltersParams.length) && (!minPrice || !maxPrice)){
						removeCheckMarkAllTypes();
						resetPriceFilter("drawerSlider");
					} else {
						resetFilterPanel();
						this.toggleFilters();
					}							
				});

			if (this.layoutSwitcher) {
				this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));

				// Set the layout to the layout in localstorage
				const layout = theme.storageUtil.get('products-layout');
				if (layout && layout === 'list') {
					const toggle = document.getElementById(`${layout}-layout-opt`);
					if (toggle) toggle.click();
				}
			}

			if (this.compareToggle) {
				this.compareToggle.addEventListener('change', this.toggleCompare.bind(this));

				const isChecked = theme.storageUtil.get('compare-toggle', true);
				if (isChecked !== null) {
					this.toggleCompare(null, isChecked, true);
				} else {
					this.toggleCompare(null, this.compareToggle.checked, false);
				}

				setTimeout(() => {
					this.classList.add('transition-ready');
					this.productsGrid.classList.add('transition-ready');
				}, 500);
			} else if (theme.settings.compareToggle === 'none') {
				this.toggleCompare(null, true, false);
			}

			if (!this.filtersComponent && this.sortBy) {
				this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
			}
		}
		handleDocumentClick(event) {
			const isDrawerOpen = document.querySelector('.boa-mobile-filters-container-active');
			const toggleButtonOpenDrawer = document.querySelector('.products-toolbar__filter-btn');

			if (isDrawerOpen) {
				const isClickInsideDrawer = isDrawerOpen.contains(event.target);
				const isClickInToggleButton = toggleButtonOpenDrawer && toggleButtonOpenDrawer.contains(event.target);

				if (!isClickInsideDrawer && !isClickInToggleButton) {
					// Close the drawer if clicked outside
					this.toggleFilters();
				}
			}
		}

		/**
		 * Updates the UI to reflect the compare state
		 * @param {object} evt - Change event object
		 * @param {boolean} checked - Whether compare is enabled or not (optional)
		 * @param {boolean} persist - Whether to persist the new state (optional)
		 */
		toggleCompare(evt, checked = null, persist = true) {
			const isChecked = evt ? evt.target.checked : checked;
			this.productsGrid.dataset.compare = isChecked;

			const compareButton = document.getElementById('compare-drawer-open');
			compareButton.classList.toggle('is-out', !isChecked);

			if (!evt && this.compareToggle) this.compareToggle.checked = isChecked;

			if (persist && !Shopify.designMode) {
				theme.storageUtil.set('compare-toggle', isChecked);
			}

			// Load scripts/styles if not already loaded
			if (isChecked) {
				const resourcesTag = document.getElementById('compare-resources');
				if (resourcesTag) {
					const resources = JSON.parse(resourcesTag.textContent);
					resources.forEach((resource) => {
						if (resource.type === 'js') {
							const script = document.createElement('script');
							script.src = resource.path;
							document.head.appendChild(script);
						} else if (resource.type === 'css') {
							const link = document.createElement('link');
							link.href = resource.path;
							link.type = 'text/css';
							link.rel = 'stylesheet';
							document.head.appendChild(link);
						}
					});
					resourcesTag.remove();
				}
			}
		}

		/**
		 * Toggles open/closed state of the filters on desktop.
		 */
		toggleFilters() {
			this.filterToggle.classList.toggle('is-active');
			this.filtersOpen = this.filterToggle.classList.contains('is-active');
			this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

			const filterContainer = document.querySelector('.boa-filters-mobile-wrapper');
			const header = filterContainer.querySelector('.boa-filters-mobile-header');
			const filters = filterContainer.querySelector('#filters');
			const footer = filterContainer.querySelector('.boa-filters-mobile-footer');
			const isDesktop = window.innerWidth > 769;

			filterContainer.classList.toggle('boa-mobile-filters-container-active');
			header.classList.toggle('boa-mobile-filters-active');
			filters.classList.toggle('boa-mobile-filters-active');
			footer.classList.toggle('boa-mobile-filters-active');
			isDesktop && document.body.classList.toggle('boa-prevent-scrolling');
			if (isDesktop && document.body.classList.contains('boa-prevent-scrolling')) {
				document.body.classList.add('boa-prevent-scrolling');
			} else {
				document.body.classList.remove('boa-prevent-scrolling');
			}
			if(filterContainer.classList.contains('boa-mobile-filters-container-active')) {
				const inputElementPriceSlider = filterContainer.querySelector('#toInput_drawerSlider');
				updateAndAdjustInputValue(inputElementPriceSlider);
			}

			// In order for mobile transition to work, the menuHeight must be initialized. 
			// When the mobile filter menu is closed however, scrollHeight is 0. 
			initilizeMenuHeight();
			updateResetButtonState(false);
		}

		/**
		 * Handles 'change' events on the layout switcher buttons.
		 * @param {object} evt - Event object.
		 */
		handleLayoutChange(evt) {
			this.productsGrid.dataset.layout = evt.target.value;
			theme.storageUtil.set('products-layout', evt.target.value);
		}

		/**
		 * Handles when a sort by dropdown is changed (and filtering is disabled)
		 * @param {object} evt - Event object.
		 */
		static handleSortByChange(evt) {
			const urlObj = new URL(window.location.href);
			urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
			urlObj.hash = 'products-toolbar';
			window.location.href = urlObj.toString();
		}
	}

	customElements.define('products-toolbar', ProductsToolbar);
}

document.addEventListener('DOMContentLoaded', function () {
	if(!document.querySelector('.swiper-container-collection')) {
		return;
	}
	const mySwiper = new Swiper('.swiper-container-collection', {
		spaceBetween: 14,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 'auto',
	});
});

